
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { TranslateService } from '@ngx-translate/core';
import { MessagingService } from './services/messaging.service';


@Component({
  selector: 'top-technology-root',
  standalone: true,
  imports: [RouterOutlet,ToastModule,ConfirmDialogModule, NgxUiLoaderModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'prime-setup';
  private _translateService = inject(TranslateService);
  constructor(
    private _messagingService: MessagingService,
    public translate: TranslateService,
  ) {
    this._translateService.addLangs(['en', 'ar', 'fr']);
    this._translateService.setDefaultLang(localStorage.getItem('language') || 'en');
  }

  ngOnInit(): void {    
    this._messagingService.requestPermission();
    this._messagingService.listenForFrontMessages();
    this.translate.get('notificationAlert').subscribe(() => {
      // Check if translation exists and permission is denied
      if (Notification.permission === 'denied' && this.translate.store.translations) {
        // alert(this.translate.instant('notificationAlert'));
      }
    });
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.action === 'navigate') {
        window.location.href = event.data.url;
        // if (event.data.payload.notifications && event.data.payload.notifications.length > 0) {
        //   this._messagingService.sendMessage(event.data.payload.notifications);
        // }
      } else if (event.data && event.data.action === 'playNotificationSound') {
        // this.playNotificationSound();
      }
    });
  }
}

